export default function(){
    if(jQuery('.potw-popup').length <= 0) return;
    if(jQuery('.potw-popup').parents('.potw-popup-standalone').length > 0) return;

    let prx_enabled = false;

    window.potwPopup = {
        open: function(){
            jQuery('html').addClass('potw-popup-opened');

            setTimeout(function(){
                prx_enabled = true;
            }, 5500);
        },
        
        close: function(){
            jQuery('html').removeClass('potw-popup-opened');
        }
    }

    //let $box    = jQuery('.potw-popup-layer-box');
    let $box    = jQuery('.potw-popup');
    let $prx    = jQuery('.potw-parallax');

    let maxX    = $box.width();
    let maxY    = $box.height();

    $box.on('mousemove', function(e){
        if(!prx_enabled) return;

        let x = e.pageX - jQuery(this).offset().left;
        let y = e.pageY - jQuery(this).offset().top;

        if (x < 0 || x > maxX || y < 0 || y > maxY) return;
        
        let xp = (((x/maxX) * 100) - 50) / 50;
        let yp = (((y/maxY) * 100) - 50) / 50;

        $prx.each(function(){
            let tx = Math.round((jQuery(this).data('x') * xp)*100) / 100;
            let ty = Math.round((jQuery(this).data('y') * yp)*100) / 100;

            jQuery(this).css({
                transform: 'translateX(' + tx + 'px) translateY(' + ty + 'px) translateZ(0)'
            });
        });
    });

    jQuery(document).on('click', '.potw-popup-overlay, .potw-popup-close', function(){
        window.potwPopup.close();

        var d = new Date(),
            cname = "potw_popup_closed",
            cvalue = "yes";
        d.setTime(d.getTime() + (1 * 60 * 60 *1000)); //1h

        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    });

    jQuery(document).on('click', '.potw-popup-open', function(){
        window.potwPopup.open();
    });
    
    window.potwPopup.open();
}